import React from "react"
import { PageContent } from "client/components"

import Iec615082010 from "./iec_61508_2010"
import Iec615081998 from "./iec_61508_1998"
// import IsaTR842002 from "./isa_tr84_2002"
import IsaTR842022 from "./isa_tr84_2022"
import VdiVde21802019 from "./vdi_vde_2180_2019"

const CalculationSettings = () => (
    <PageContent>
        <Iec615082010 />
        <Iec615081998 />
        {
            // TODO: temporarily disabled
            // <IsaTR842002 />
        }
        <IsaTR842022 />
        <VdiVde21802019 />
    </PageContent>
)
export default CalculationSettings
